import { jsx as _jsx } from "react/jsx-runtime";
import { AdvantagesSection } from '../../advantages-section/AdvantagesSectionV2';
const AdvantagesBlock = ({ advantages }) => {
    if (!(advantages === null || advantages === void 0 ? void 0 : advantages.length))
        return null;
    return _jsx(AdvantagesSection, { items: advantages, variant: "bodyM" });
};
export default AdvantagesBlock;
